import { render, staticRenderFns } from "./leave-details.vue?vue&type=template&id=bc6665ca&scoped=true&"
import script from "./leave-details.vue?vue&type=script&lang=js&"
export * from "./leave-details.vue?vue&type=script&lang=js&"
import style0 from "./leave-details.vue?vue&type=style&index=0&id=bc6665ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6665ca",
  null
  
)

export default component.exports